/* FT GUYS - header state on scroll.

   Horizon already pins the header (enable_sticky_header: always). What it does
   not do is change its appearance once you leave the top of the page, so the
   header carried the same frosted panel whether it was floating over the hero
   video or sitting on a black section - where 55% dark over near-black is simply
   black, and the glass does nothing but cost a blur.

   Two states now:
     at rest  - fully transparent, no blur, no border. Over the hero it disappears
                and the video runs edge to edge.
     stuck    - frosted panel, hairline border, slight lift. Signals that content
                is passing underneath.

   Threshold is 24px with an 8px release, deliberately asymmetric. A single
   threshold makes the header flicker between states when someone rests a finger
   mid-scroll and the page jitters by a pixel.

   Reads scrollY inside rAF and writes only a class, so no layout is forced during
   scroll - the usual cause of janky sticky headers.
*/
(function () {
  'use strict';

  var group = document.getElementById('header-group');
  if (!group) return;

  var ON = 24;    // scrolled past this -> frost
  var OFF = 8;    // back above this -> clear again
  var stuck = false;
  var ticking = false;

  function apply() {
    ticking = false;
    var y = window.scrollY || window.pageYOffset || 0;
    if (!stuck && y > ON) {
      stuck = true;
      group.classList.add('is-stuck');
    } else if (stuck && y < OFF) {
      stuck = false;
      group.classList.remove('is-stuck');
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(apply);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  apply();
})();
